import rumCustomEventsHelpers from '../services/events/rumCustomEventsHelpers';
import log from '../services/logger/log';
import loyaltyService from '../services/loyalty/loyaltyService';
import networkStatusService from '../services/networkStatusService';
import serviceWorkerService from '../services/serviceWorkerService';
import userSessionManagementService from '../services/userSessionManagementService';
import {selectIsAuthorized} from '../state/selectors/auth';
import {selectIsOnline, selectIsRetail} from '../state/selectors/global';
import {getState} from '../state/store';
import useAppVisibilityChange from './useAppVisibilityChange';

const useAppVisibilityHandler = () => {
    const onVisible = async () => {
        rumCustomEventsHelpers.onVisible();
        serviceWorkerService.postMessageAppOpened();
        await updateSessionData();
    };

    const onHidden = () => {
        rumCustomEventsHelpers.onHidden();
    };

    useAppVisibilityChange({onVisible, onHidden});
};

const updateSessionData = async () => {
    const isOnline = selectIsOnline(getState());
    const isRetail = selectIsRetail(getState());
    const isAuthorized = selectIsAuthorized(getState());

    if (!isOnline) {
        log.info(`useAppVisibilityHandler: App is offline, waiting for online status.`);

        await networkStatusService.waitOnline();
    }

    if (!isAuthorized) {
        log.info(`useAppVisibilityHandler: User is not authorized, skipping session update.`);
        return;
    }

    await Promise.allSettled([
        !isRetail && loyaltyService.getBadgeData(),
        userSessionManagementService.validateUserSession(),
    ]);
};

export default useAppVisibilityHandler;
